export const dataURLtoBlob = (dataurl: string): Blob => {
  let arr: any = dataurl.split(',');

  let mime = arr[0]?.match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
}

export const toDataURL = (url: string, callback: Function) => {
  const xhr = new XMLHttpRequest();
  xhr.withCredentials = true;

  xhr.onload = function () {
    const reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    }
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

export const asyncToDataURL = async (url: string) => {
  return new Promise((resolve) => {
    toDataURL(url, resolve);
  });
}